import i18nSetup from "./i18n-setup"

$(document).on('turbolinks:load', function() {
  const i18n = i18nSetup()
  $('.ch-tabs .item').not('a').tab()
  $('.ui.dropdown').dropdown({
    message: {
      noResults: i18n.t('web.javascript.dropdown.no_results')
    }
  })
});
